import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleDisclosure","AffiliateDisclosure"] */ "/app/src/app/_components/Article/ArticleHeader/ArticleDisclosure.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BylineReadTime"] */ "/app/src/app/_components/Article/ArticleHeader/BylineReadTime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleSourceButton"] */ "/app/src/app/_components/Article/ArticleHeader/GoogleSourceButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleWrapper"] */ "/app/src/app/_components/Article/ArticleWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActionableIcon"] */ "/app/src/app/_components/common/ActionableIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/app/src/app/_components/common/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Icon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/iframe.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Image.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialLinksDropdown"] */ "/app/src/app/_components/common/SocialLinksDropdown.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/common/StnVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrinityPlayerScript"] */ "/app/src/app/_components/TrinityPlayer/TrinityPlayerScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BasicPopover"] */ "/app/src/app/_components/ui/BasicPopover.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/app/_components/ui/Button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/ui/ButtonV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root"] */ "/app/src/app/_components/ui/primitives/Separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionDescription"] */ "/app/src/app/_components/widgets/common/AccordionDescription.tsx");
